<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Pencairan QRIS</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 50px"
            >
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Total Menunggu</span>
                            </div>
                            <h1 class="total">
                                <span
                                    >Rp
                                    {{
                                        qris_settiement_summary.sum_of_settlement_waiting
                                            | rupiah
                                    }}</span
                                >
                            </h1>
                        </div>
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Total Selesai</span>
                            </div>
                            <h1 class="total">
                                <span
                                    >Rp
                                    {{
                                        qris_settiement_summary.sum_of_settlement_completed
                                            | rupiah
                                    }}</span
                                >
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 50px">
                <div class="section mt-2">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <datetime
                                        v-model="qris_settlement_meta.startDate"
                                        class="theme-primary"
                                        :input-class="'form-control'"
                                        auto
                                        :title="'Mulai Tanggal'"
                                    ></datetime>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <datetime
                                        v-model="qris_settlement_meta.endDate"
                                        class="theme-primary"
                                        :input-class="'form-control'"
                                        auto
                                        :title="'Sampai Tanggal'"
                                    ></datetime>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ButtonLoader
                        :loading="loadingButtonFilter"
                        :styled="'btn btn-primary btn-block mt-1'"
                        @click.native="submitFilterData()"
                    >
                        Filter Data</ButtonLoader
                    >
                </div>
                <div class="section full mt-3">
                    <div>
                        <div
                            class="text-center mt-5 pt-5 mb-5 pb-5"
                            v-if="loadingData"
                        >
                            <span
                                class="spinner-border spinner-border mr-1 text-primary"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        </div>
                        <div v-else-if="qris_settlements.data.length > 0">
                            <!-- item -->
                            <ul
                                class="listview image-listview-product full ml-0 mr-0"
                            >
                                <li
                                    v-for="item in qris_settlements.data"
                                    :key="item.id"
                                >
                                    <router-link
                                        :to="{
                                            name: 'qris.settlement.detail',
                                            params: {
                                                id: item.id,
                                            },
                                        }"
                                        class="item pl-2 pr-3 pt-2 pb-2"
                                    >
                                        <div class="in">
                                            <div style="width: 90%">
                                                <header>
                                                    {{ item.created_at | date }}
                                                    ({{
                                                        item.created_at | time
                                                    }}
                                                    WIB)
                                                </header>
                                                <h4>
                                                    Rp
                                                    {{
                                                        item.total_amount
                                                            | rupiah
                                                    }}
                                                </h4>
                                                <footer>
                                                    Biaya :
                                                    <b
                                                        >Rp
                                                        {{
                                                            (parseFloat(
                                                                item.total_fee
                                                            ) +
                                                                parseFloat(
                                                                    item.total_fee_fast_settlement
                                                                ))
                                                                | rupiah
                                                        }}</b
                                                    >
                                                </footer>
                                            </div>
                                        </div>
                                        <span class="text-muted text-right">
                                            <h5
                                                class="mb-0"
                                                style="font-weight: normal"
                                            >
                                                Rp
                                                {{
                                                    item.total_amount_disbursed
                                                        | rupiah
                                                }}
                                            </h5>
                                            <div style="margin-bottom: 3px">
                                                <strong
                                                    class="text-secondary"
                                                    style="font-weight: bold"
                                                    v-if="
                                                        item.settlement_type ==
                                                        'normal_settlement'
                                                    "
                                                    >Normal</strong
                                                >
                                                <strong
                                                    class="text-warning"
                                                    style="font-weight: bold"
                                                    v-else
                                                    ><ion-icon
                                                        name="flash-outline"
                                                    ></ion-icon>
                                                    Dipercepat</strong
                                                >
                                            </div>
                                            <div>
                                                <label
                                                    class="badge badge-warning pl-2 pr-2"
                                                    v-if="
                                                        item.status == 'waiting'
                                                    "
                                                    >Menunggu</label
                                                >
                                                <label
                                                    class="badge badge-primary pl-2 pr-2"
                                                    v-else-if="
                                                        item.status == 'process'
                                                    "
                                                    >Sedang diproses</label
                                                >
                                                <label
                                                    class="badge badge-success pl-2 pr-2"
                                                    v-else-if="
                                                        item.status == 'success'
                                                    "
                                                    >Berhasil</label
                                                >
                                            </div>
                                        </span>
                                    </router-link>
                                </li>
                            </ul>
                            <div
                                class="m-2 text-center"
                                v-if="
                                    qris_settlements.next_page_url &&
                                    qris_settlements.to >=
                                        qris_settlements.per_page
                                "
                            >
                                <ButtonLoader
                                    :loading="loading.pagination"
                                    :styled="'btn btn-primary rounded mr-1 mb-1'"
                                    @click.native="
                                        getQrisSettlement(
                                            qris_settlements.next_page_url
                                        )
                                    "
                                    >Lihat lebih banyak</ButtonLoader
                                >
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <img
                                :src="require('@/assets/image/empty.webp')"
                                alt="404"
                                class="w-50"
                            /><br />
                            <h4 class="mb-0 text-secondary">
                                Belum ada transaksi
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
                loadingButtonFilter: false,
                loadingData: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.getQrisSettlement().then(() => {
                this.loadingApp = false;
            });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_settlements: state => state.qris_settlements,
                qris_settiement_summary: state => state.qris_settiement_summary,
                qris_settlement_meta: state => state.qris_settlement_meta,
                loading: state => state.loading,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', [
                'getQrisSettlement',
                'getQrisSettlementSummary',
            ]),
            ...mapMutations('qrisMerchant', ['RESET_QRIS_SETTLEMENT']),
            submitFilterData() {
                this.RESET_QRIS_SETTLEMENT();
                this.loadingData = true;
                this.loadingButtonFilter = true;
                this.getQrisSettlementSummary();
                this.getQrisSettlement().then(() => {
                    this.loadingData = false;
                    this.loadingButtonFilter = false;
                });
            },
        },

        mounted() {},
        destroyed() {
            this.RESET_QRIS_SETTLEMENT();
        },
    };
</script>
